import { ClientTable } from 'vue-tables-2';
import { select } from '../shared/utils/dom';
import { delimiters } from '../shared/constants';
import loadingMixin from '../shared/vue/mixins/loading';
import { deletePayment } from './api';
import dataLayerPush from '../shared/utils/analytics';

export default function managePayments() {
  const el = select('[data-vue-app="manage-payments"]');
  if (!el) {
    return;
  }

  Vue.use(ClientTable);

  const data = {};
  data['columns'] = ['bankAccount'];
  data['hasMounted'] = true;
  data['loading'] = false;
  data['success'] = false;
  const options = {};
  options['filterable'] = false;
  options['sortable'] = [];
  options['headings'] = {
    bankAccount: 'Bank Account',
  };
  options['perPage'] = 5;
  data['options'] = options;
  data['hideAddAccount'] = 'False';

  new Vue({
    el,
    delimiters,
    mixins: [loadingMixin],
    data() {
      data['tableData'] = window.VueTables ? window.VueTables.bankAccounts : [];

      return data;
    },
    created() {
      Event.$on('ConfirmRemoveBankAccount', (bankAccount) => {
        if (bankAccount.bankAccount) {
          this.confirmRemoveBankAccount(bankAccount.bankAccount);
        } else {
          Event.$emit('UpdateBankAccountToRemoveCompleted', { removeSuccess: false });
        }
      });
    },
    mounted() {
      this.hideAddAccount = (this.$el.dataset && this.$el.dataset.hideAddAccount) ? this.$el.dataset.hideAddAccount : 'False';
    },
    methods: {
      removeBankAccount(bankAccount) {
        this.success = false;
        Event.$emit('UpdateBankAccountToRemove', { bankAccount });
      },
      confirmRemoveBankAccount(bankAccount) {
        this.loading = true;
        if (window.ldcCode === 'NI') {
          deletePayment.deleteCISPaymentMethod(bankAccount)
            .then(() => {
              this.loading = false;
              this.success = true;
              dataLayerPush('DeleteBankAccount');
              this.tableData = this.tableData.filter((item) => item.accountNumber != null && item.accountNumber !== bankAccount.accountNumber);
              Event.$emit('UpdateBankAccountToRemoveCompleted', { removeSuccess: true });
              this.hideAddAccount = 'False';
            })
            .catch(err => {
              this.loading = false;
              console.log(err);
              Event.$emit('UpdateBankAccountToRemoveCompleted', { removeSuccess: false });
            });
        } else {
          deletePayment.deleteDISPaymentMethod(bankAccount)
            .then(() => {
              this.loading = false;
              this.success = true;
              dataLayerPush('DeleteBankAccount');
              this.tableData = this.tableData.filter((item) => item.eftKey != null && item.eftKey !== bankAccount.eftKey);
              Event.$emit('UpdateBankAccountToRemoveCompleted', { removeSuccess: true });
              if (this.tableData.length < 20) {
                this.hideAddAccount = 'False';
              }
            })
            .catch(err => {
              this.loading = false;
              console.log(err);
              Event.$emit('UpdateBankAccountToRemoveCompleted', { removeSuccess: false });
            });
        }
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/managePayments.js